import script from "./DefGoToTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefGoToTop.vue?vue&type=script&lang=ts&setup=true"

import "./DefGoToTop.vue?vue&type=style&index=0&id=47e42ae2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e42ae2"]])

export default __exports__